import { z } from "zod";
function isSalesforceIntegrationSettings(settings) {
  return "instance_url" in settings && (settings.instance_url === null || typeof settings.instance_url === "string") && "is_enabled" in settings && typeof settings.is_enabled === "boolean";
}
function isSlackIntegrationSettings(settings) {
  return "channel_id" in settings && (settings.channel_id === null || typeof settings.channel_id === "string");
}
const teamsIntegrationSettingsSchema = z.object({
  tenant_id: z.string().nullable()
});
function isTeamsIntegrationSettings(settings) {
  return teamsIntegrationSettingsSchema.safeParse(settings).success;
}
function isInternalTwilioSubAccountIntegrationSettings(provider, settings) {
  return provider === IntegrationProvider.INTERNAL_TWILIO_SUB_ACCOUNT && "account_sid" in settings;
}
function isExternalTwilioSubAccountIntegrationSettings(provider, settings) {
  return provider === IntegrationProvider.EXTERNAL_TWILIO_SUB_ACCOUNT && "account_sid" in settings;
}
const ExternalTwilioPartner = {
  FOUNTAIN: "fountain"
};
function isTwilioSubAccountIntegrationSettings(provider, settings) {
  return isInternalTwilioSubAccountIntegrationSettings(provider, settings) || isExternalTwilioSubAccountIntegrationSettings(provider, settings);
}
function isGreenhouseIntegrationSettings(settings) {
  return "advancement_stage_name" in settings && (settings.advancement_stage_name === null || typeof settings.advancement_stage_name === "string") && "integration_system_user_email" in settings && (settings.integration_system_user_email === null || typeof settings.integration_system_user_email === "string");
}
function isRingCentralRecordingS3IntakeIntegrationSettings(settings) {
  return "client_id" in settings && "enc_client_secret" in settings && "enc_jwt" in settings;
}
const IntegrationProvider = {
  FOUNTAIN: "fountain",
  INTERNAL_TWILIO_SUB_ACCOUNT: "internal_twilio_sub_account",
  EXTERNAL_TWILIO_SUB_ACCOUNT: "external_twilio_sub_account",
  SALESFORCE: "salesforce",
  SLACK: "slack",
  TEAMS: "teams",
  GREENHOUSE: "greenhouse",
  RINGCENTRAL_RECORDING_S3_INTAKE: "ringcentral_recording_s3_intake"
};
const allIntegrationProviders = [
  IntegrationProvider.FOUNTAIN,
  IntegrationProvider.INTERNAL_TWILIO_SUB_ACCOUNT,
  IntegrationProvider.EXTERNAL_TWILIO_SUB_ACCOUNT,
  IntegrationProvider.SALESFORCE,
  IntegrationProvider.SLACK,
  IntegrationProvider.TEAMS,
  IntegrationProvider.GREENHOUSE,
  IntegrationProvider.RINGCENTRAL_RECORDING_S3_INTAKE
];
const integrationProviderSchema = z.enum(allIntegrationProviders);
function isIntegrationProvider(value) {
  return allIntegrationProviders.includes(value);
}
export {
  ExternalTwilioPartner,
  IntegrationProvider,
  isExternalTwilioSubAccountIntegrationSettings,
  isGreenhouseIntegrationSettings,
  isIntegrationProvider,
  isInternalTwilioSubAccountIntegrationSettings,
  isRingCentralRecordingS3IntakeIntegrationSettings,
  isSalesforceIntegrationSettings,
  isSlackIntegrationSettings,
  isTeamsIntegrationSettings,
  isTwilioSubAccountIntegrationSettings
};
//# sourceMappingURL=integration.js.map
